import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import TableCell from "@mui/material/TableCell";

const PriceCell = ({
  value,
  setValue,
  disabled,
  onFocus,
}: {
  value: number;
  setValue: (value: number) => void;
  disabled: boolean;
  onFocus: () => void;
}) => {
  if (disabled) {
    return (
      <TableCell
        className="rowValue currentCell"
        style={{ color: "rgba(0,0,0, .4)", width: 200 }}
      >
        ${value}
      </TableCell>
    );
  }

  return (
    <TableCell className="rowValue currentCell" style={{ width: 200 }}>
      <TextField
        size="small"
        variant="standard"
        // type="number"
        value={value}
        onChange={(e) => {
          let stringVal = String(e.target.value).replaceAll(",", "");
          const num = Number(stringVal.replace(".", ""));
          if (Number.isNaN(num)) {
            return;
          }

          if (stringVal.endsWith(".")) {
            setValue(stringVal as any);
            return;
          }

          if (stringVal.startsWith("0") && stringVal.length > 1) {
            stringVal = stringVal.slice(1, stringVal.length);
          }

          const split = stringVal.split(".");
          const val = split[0] + (split[1] ? `.${split[1].slice(0, 2)}` : "");

          setValue(Number(val));
        }}
        onFocus={onFocus}
        InputProps={{
          style: { fontSize: ".9em" },
          startAdornment: (
            <InputAdornment
              position="start"
              //   sx={{ fontSize: 10 }}
              style={{ padding: 0, margin: 0, paddingRight: 5 }}
            >
              <div style={{ fontSize: "1.2em" }}>$</div>
            </InputAdornment>
          ),
        }}
      />
    </TableCell>
  );
};

export default PriceCell;
